import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type StaffMemberUpdateFailedAction = {
	type: 'STAFF_MEMBER_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): StaffMemberUpdateFailedAction => ({
	type: 'STAFF_MEMBER_UPDATE_FAILED',
	payload,
});
